import {
  DOOR_CARRIAGE_SUSTAINABILITY_PRODUCTS,
  GLOBAL_SUSTAINABILITY_PRODUCTS,
  SEA_FREIGHT_SUSTAINABILITY_PRODUCTS,
} from '@forto-dev/shipment-models'

import { SustainabilityDTOServiceType } from '@/clients/booking'
import { useLocalisation } from '@/utils/localisation'

export const useSustainabilityLabels = (): Record<string, string> => {
  const { translate } = useLocalisation()

  return {
    offerLabel: 'Sustainability Offer',
    [SustainabilityDTOServiceType.DoorCarriageOrigin]: 'Pre-Carriage',
    [SustainabilityDTOServiceType.SeaFreight]: 'Main-Carriage',
    [SustainabilityDTOServiceType.DoorCarriageDestination]: 'On-Carriage',
    [SustainabilityDTOServiceType.Global]: 'Global',
    [GLOBAL_SUSTAINABILITY_PRODUCTS.oceanPlasticPrevention]: translate(
      'booking.sustainability.product.ocean_plastic_prevention'
    ),
    [DOOR_CARRIAGE_SUSTAINABILITY_PRODUCTS.biofuel]: translate('booking.sustainability.product.biofuel'),
    [DOOR_CARRIAGE_SUSTAINABILITY_PRODUCTS.railFreightLight]: translate(
      'booking.sustainability.product.rail_freight_light'
    ),
    [DOOR_CARRIAGE_SUSTAINABILITY_PRODUCTS.railFreight100]: translate(
      'booking.sustainability.product.rail_freight_100'
    ),
    [SEA_FREIGHT_SUSTAINABILITY_PRODUCTS.biofuelLight]: translate('booking.sustainability.product.biofuel_light'),
    [SEA_FREIGHT_SUSTAINABILITY_PRODUCTS.biofuel25]: translate('booking.sustainability.product.biofuel_25'),
    [SEA_FREIGHT_SUSTAINABILITY_PRODUCTS.biofuel50]: translate('booking.sustainability.product.biofuel_50'),
    [SEA_FREIGHT_SUSTAINABILITY_PRODUCTS.biofuelMax]: translate('booking.sustainability.product.biofuel_max'),
  }
}
